import { createContext, FC, ReactNode, useContext, useEffect, useState } from "react";
import { ShipTo } from "models/ShipTo";
import { useAuth } from "contexts/AuthProvider";
import { HttpRequest } from "libs/http-helper";
import useLocalStorage from "hooks/useLocalStorage";

export type ShipToContextType = {
  loading: boolean,
  shipTos: ShipTo[]
  selectShipTo: (shipToNumber: number) => void;
  selectedShipTo: () => ShipTo;
};

const ShipToContextDefaultState: ShipToContextType = {
  loading: false,
  shipTos: null as any as ShipTo[],
  selectShipTo: (shipToNumber: number) => { },
  selectedShipTo: () => null as any as ShipTo
};

export const ShipToContext = createContext(ShipToContextDefaultState);

interface ShiptoProviderProps {
  children: ReactNode;
}

const ShiptoProvider: FC<ShiptoProviderProps> = ({ children }) => {
  const key = 'airproducts.onlineshop.selectedshipto';
  const { authenticating, isAuthenticated, getToken } = useAuth();
  const [shipTos, setShipTos] = useState<ShipTo[]>([]);
  const [loading, setLoading] = useState(false);
  const [getLSItem, setLSItem, removeLSItem] = useLocalStorage();

  const getShipTos = (): ShipTo[] => loading ? [] : shipTos;

  const selectShipTo = (shipToNumber: number) => {
    const shipTo = shipTos.find(s => s.shipToNumber === shipToNumber);
    shipTo && setLSItem(key, JSON.stringify(shipTo));
  };

  const selectedShipTo = (): ShipTo => JSON.parse(getLSItem(key) as string) ?? {};

  useEffect(() => {
    console.log(`[ShiptoProvider] authenticating changed to: ${authenticating}`);
    async function getUserShipTos() {
      if (!authenticating && isAuthenticated()) {
        setLoading(true);
        const data = await HttpRequest<ShipTo[]>("get", `${import.meta.env.VITE_ONLINE_SHOP_RUN_TIME_API_URL}/user/shipto`, null, true, getToken());
        setShipTos(data);
        setLoading(false);
      }
    };
    getUserShipTos();
  }, [authenticating]);

  return <ShipToContext.Provider value={{ loading, shipTos, selectShipTo, selectedShipTo }}>
    {children}
  </ShipToContext.Provider>
};

export default ShiptoProvider;
export const useShipTo = () => useContext(ShipToContext);